import { createSlice } from "@reduxjs/toolkit";

const initState = {
  byId: {},
  allIds: [],
  activeDocumentId: null,
  isShowSummary: false,
  isAllowReview: false,
};

const documentSlice = createSlice({
  name: "documents",
  initialState: initState,
  reducers: {
    setActiveDocument(state, { /** action, */ payload }) {
      state.activeDocumentId = payload;
    },
    setDocument(state, { /** action, */ payload }) {
      if (!state.byId[payload.id]) {
        state.allIds.push(payload.id);
      }
      state.byId[payload.id] = payload;
    },
    setDocuments(state, { /** action, */ payload }) {
      let documents = [];
      for (var document of payload) {
        documents.push(document.id);
        state.byId[document.id] = document;
      }
      state.allIds = documents;
    },
    allowReview(state /** , { action, payload } */) {
      state.isShowSummary = true;
      state.isAllowReview = true;
    },
    closeReview(state /** , { action, payload } */) {
      state.isShowSummary = false;
      state.isAllowReview = false;
    },
  },
});

export const documentActions = documentSlice.actions;
export const documentReducer = documentSlice.reducer;
